import classNames from 'classnames'
import { PropsWithChildren } from 'react'
import { NavLink } from 'react-router-dom'

import styles from './Button.module.scss'

type ButtonType = 'primary' | 'secondary' | 'tetriary'

export interface IButtonProps {
  label?: string;
  className?: string;
  type?: ButtonType;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  to?: string;
  wide?: boolean;
  submit?: boolean;
  isNewTab?: boolean;
  submitting?: boolean;
  tabletHalfWidth?: boolean;
  preventActiveClassName?: boolean;
}

const getNewTabProps = (isNewTab = false) => (!isNewTab ? {} : {
  target: '_blank',
  rel: 'noopener noreferrer',
})

const Button = ({
  label,
  className,
  children,
  onClick,
  to,
  type = 'primary',
  wide = false,
  submit = false,
  isNewTab = false,
  submitting = false,
  preventActiveClassName = false,
}: PropsWithChildren<IButtonProps>) => {
  const content = label || children

  const elClassName = classNames(
    styles.main,
    styles[type],
    wide && styles.wide,
    className,
  )

  if (to) {
    return (
      <NavLink
        {...getNewTabProps(isNewTab)}
        to={to}
        className={({ isActive }) => classNames(elClassName, !preventActiveClassName && isActive && styles.active)}
      >
        {content}
      </NavLink>
    )
  }

  return (
    <button className={elClassName} onClick={onClick} type={submit ? 'submit' : 'button'} disabled={submitting}>
      {content}
    </button>
  )
}

export default Button
